export default {
  GENERAL_COURSES: 'GENERAL_COURSES',

  SET_CHOOSEN_DIRECTION_SUCCES: 'SET_CHOOSEN_DIRECTION_SUCCES',
  SET_MESSAGE: 'SET_MESSAGE',

  START_FETCHING_GENERAL: 'START_FETCHING_GENERAL',
  STOP_FETCHING_GENERAL: 'STOP_FETCHING_GENERAL',

  SET_ERROR_GENERAL: 'SET_ERROR_GENERAL',
};